import React from "react";
import { Row, Col } from "reactstrap";
import Section from "./Section";
import { useImages } from "../../hooks/generalHooks";
import MediaDisplay from "./MediaDisplay";
import { normalizeString } from "../../services/utils";

function Gallery(props) {
  const { title, id, files } = props;

  // this array will be filled with  rows of images
  const rows = [];
  if (files) {
    for (let i = 0; i < files.length; i += 2) {
      rows[i] =
        i < files.length - 1 ? ( // two images per row
          <Row key={i} className=" d-flex justify-content-center">
            <Col>
              <MediaDisplay
                displayName={normalizeString(files[i].split("-")[0])}
                fileName={files[i]}
                resourceId={id}
              />
            </Col>
            <Col>
              <MediaDisplay
                displayName={normalizeString(files[i + 1].split("-")[0])}
                fileName={files[i + 1]}
                resourceId={id}
              />
            </Col>
          </Row>
        ) : (
          // last image needs to be in a single column so it's nicely centered
          <Row key={i} className=" d-flex justify-content-center">
            <Col className=" col-xs-12 col-sm-12 col-lg-6 col-xl-6 col-md-6">
              <MediaDisplay
                displayName={normalizeString(files[i].split("-")[0])}
                fileName={files[i]}
                resourceId={id}
              />
            </Col>
          </Row>
        );
    }
  } else {
    // empty array means nothing to show
    return null;
  }
  return <Section title={title}>{rows}</Section>;
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/views/components/Gallery.jsx